<template lang="pug">
  .buscador
    form.px-2
      .form-group.row
        b-form-group#input-group-1.col-sm-3.col-form-label(label='Tema:' label-for='input-tema')
        .col-sm-9
          b-form-input#input-tema(v-model='busqueda.tema')
      .form-group.row
        b-form-group#input-group-3.col-sm-3.col-form-label(label='Tipo de Solicitud de Informacion:' label-for='input-tipo')
        .col-sm-9
          b-form-select(v-model='busqueda.tipo_rfi_codigo' :options='tipoRfiList' value-field="codigo" text-field="descripcion")
      .form-group.row
        b-form-group#input-group-4.col-sm-3.col-form-label(label='Fecha desde:' label-for='input-fecha-desde')
        .col-sm-3
          b-form-datepicker#input-fecha-desde(v-model='busqueda.fecha_desde' placeholder="Ingrese una fecha")
        b-form-group#input-group-5.col-sm-1.col-form-label.ml-auto(label='Fecha hasta:' label-for='input-fecha-hasta')
        .col-sm-3
          b-form-datepicker#input-fecha-hasta(v-model='busqueda.fecha_hasta' placeholder="Ingrese una fecha")
      .form-group.row
        b-form-group#input-group-2.col-sm-3.col-form-label(label='Estado:' label-for='input-estado')
        .col-sm-3
          b-form-select(v-model='busqueda.estado_codigo' :options='estadoRfiList' value-field="codigo" text-field="descripcion")
        b-form-group#input-group-6.col-sm-1.col-form-label.ml-auto(v-if="this.isFuncionario"
        label='Convocante:' label-for='input-convocante')
        .col-sm-3
          div(v-if="this.isFuncionario")
            b-form-input#input-with-list(v-model='convocante' list='input-list' @input="(event) => this.convocante=event")
            b-form-datalist#input-list(:options='unidadesContratacion' v-model='this.convocante' text-field= 'descripcion')




    div.float-right
      button.btn.btn-primary.m-1(@click.prevent='add()' v-if="this.isConvocante || this.isConvenio") Crear Solicitud de Informacion
    button.btn.btn-secondary.m-1(@click.prevent='buscar()') Buscar
    button.btn.btn-secondary.m-1(@click.prevent='limpiar()') Limpiar

    br
    br
    .card.table-panel(id='')
      .card-header
        h3.card-title
          | RFI - Solicitudes de Información
      .card-body.table-responsive
        table.table.table-bordered.table-condensed.table-striped.table-hover
          thead
            tr
              th.text-center.w-25 Tema
              th.text-center Estado
              th.text-center.w-25 Tipo de Solicitud de Información
              th.text-center Fecha Creación
              th.text-center Fecha Publicación
              th.text-center Fecha de Recepcion de Propuestas
              th.text-center Acciones
          tbody(v-for='row in listaSolicitudes')
            tr
              td {{ row.tema }}
              td.text-center {{row.descripcion_estado}}
              td {{row.descripcion_tipo}}
              td {{convertDate(row.fecha_creacion)}}
              td {{convertDate(row.fecha_publicacion)}}
              td {{convertDate(row.recepcion_propuesta_fecha_fin)}}
              td
                .btn-group
                  b-dropdown#dropdown-1.m-md-2(text='Acciones')
                    b-dropdown-item(@click.prevent='visualizar(row.id)') Visualizar
                    b-dropdown-item(@click.prevent='modificar(row.id)' v-if="isConvocante || isConvenio") Modificar
                    //b-dropdown-item(@click.prevent='borrar()' v-if="isConvocante") Borrar
                    //b-dropdown-item(@click.prevent='cancelar()' v-if="isConvocante") Cancelar




</template>

<script>
import {HTTP} from "../http";
import functions from "../mixins/functions";

export default {
  name: "TablaSolicitudInformacion",
  mixins: [functions],
  data() {
    return {
      tipoRfiList: [ ],
      estadoRfiList: [],
      unidadesContratacion: [],
      listaSolicitudes: [ ],
      convocante: null,
      isConvocante: Boolean,
      isFuncionario: Boolean,
      isConvenio: Boolean,
      busqueda: {
        tema: null,
        tipo_rfi_codigo: null,
        estado_codigo: null,
        fecha_desde: null,
        fecha_hasta: null,
        unidad_contratacion_id: null,
        no_borradores: null,
        origen_rfi: null,
      },

    }
  },
  async mounted() {
    this.activeSpinner();
    try {
      this.tipoRfiList = (await HTTP.get('/selectores/parametros', { params: {dominio: "RFI_TIPO_SOLICITUD_INFORMACION"}})).data.list;
      this.estadoRfiList = (await HTTP.get('/selectores/parametros', { params: {dominio: "RFI_ESTADO"}})).data.list;
      this.unidadesContratacion = (await HTTP.get('/selectores/uocs-entidad')).data.list;

      this.isConvocante = this._checkPerfil('rfi_convocante_admin')
      this.isFuncionario = this._checkPerfil('rfi_funcionario_consulta')
      this.isConvenio = this._checkPerfil('rfi_convenio_admin')

      if(this.isConvocante)
        if(typeof(sessionStorage.getItem("uoc")) !== 'undefined' || sessionStorage.getItem("uoc")!== null)
          this.busqueda.unidad_contratacion_id = sessionStorage.getItem("uoc")
      if(this.isFuncionario)
        this.busqueda.no_borradores = 'BORRADOR'
      if(this.isConvenio)
        this.busqueda.origen_rfi = 'CONVENIO'


      this.listaSolicitudes = (await HTTP.get('/solicitudInformacion/buscadorSolicitudes', {
        params: {
          unidad_contratacion_id: this.busqueda.unidad_contratacion_id,
          funcionario: this.busqueda.no_borradores,
          origen_rfi: this.busqueda.origen_rfi,
        }
      })).data.list;
    }catch (error) {
      console.log(error)
    }
    this.desactiveSpinner();
  },
  methods: {
    add: function () {
      this.$router.push({path: "solicitud_informacion/crear"})
    },

    modificar: function (id) {
      this.$router.push({path: "/solicitud_informacion/modificar", query:{id: encodeURIComponent(id)}});
    },
    visualizar: function (id) {
      this.$router.push({path: "solicitud_informacion/visualizar", query:{id: encodeURIComponent(id)}});
    },


    limpiar: function () {
      this.busqueda.tema = null
      this.busqueda.tipo_rfi_codigo = null
      this.busqueda.estado_codigo = null
      this.convocante = null
      this.busqueda.fecha_desde = null
      this.busqueda.fecha_hasta = null
      if(!this.isConvocante)
        this.busqueda.unidad_contratacion_id = null
    },
    buscar: async function () {
      /* TODO MEJORAR EL METODO DE OBTENCION DE UOC_ID*/
      for(let field of this.unidadesContratacion) {
        if(this.convocante === field.descripcion) {
          this.busqueda.unidad_contratacion_id = field.id
        }
      }

      this.listaSolicitudes = []
      try {
        this.listaSolicitudes = (await HTTP.get('/solicitudInformacion/buscadorSolicitudes', {
          params: {
            tema: this.busqueda.tema,
            tipo_rfi_codigo: this.busqueda.tipo_rfi_codigo,
            estado_codigo: this.busqueda.estado_codigo,
            unidad_contratacion_id: this.busqueda.unidad_contratacion_id,
            fecha_desde: this.busqueda.fecha_desde,
            fecha_hasta: this.busqueda.fecha_hasta,
            funcionario: this.busqueda.no_borradores

          }
        })).data.list;
      } catch (ex) {
        this.listaSolicitudes = [];
      }
    },
  }
}

</script>

<style scoped>

</style>
